import {ICandidateApiFilterOptions} from "api/candidateApi/form";
import {TPaginationParam} from "api/candidateApi/types";
import HttpClient from "api/index";
import {TProjectInsightsFilter} from "mapx-pages/Project/Insights/ProjectInsightsFilter/types";

export type TProjectInsightsPayload = {
	filters?: ICandidateApiFilterOptions;
};

class MapxProjectInsightsApi extends HttpClient {
	async getProjectStats(projectId: number, config = {}) {
		return this.doGet(`/mapx/projects/${projectId}/stats`, config);
	}

	async getPaginatedIndustriesReport(
		projectId: number,
		pagination: TPaginationParam = {page: 1, per_page: 20},
		config = {},
	) {
		return await this.doGet(
			`/projects/${projectId}/industries-report?page=${pagination.page}&per_page=${pagination.per_page}`,
			config,
		);
	}

	async getGenderDiversityReport(
		projectId: number,
		formData: TProjectInsightsPayload,
		config = {},
	) {
		return await this.doPost(
			`/projects/${projectId}/gender-diversity-report`,
			formData,
			config,
		);
	}

	// async getIndustriesReport(projectId: number, config = {}) {
	// 	return await this.doGet(`/mapx/projects/${projectId}/industries-report`, config);
	// }

	async getEthnicDiversityReport(
		projectId: number,
		formData: TProjectInsightsPayload,
		config = {},
	) {
		return await this.doPost(
			`/projects/${projectId}/ethnic-diversity-report`,
			formData,
			config,
		);
	}

	async getFitToBriefReport(formData: TProjectInsightsFilter, projectId: number, config = {}) {
		return await this.doPost(`/projects/${projectId}/fit-to-brief-report`, formData, config);
	}

	// async getSpecialismPositionsReport() {
	// 	return await this.doGet("/mapx/specialism-positions-report");
	// }

	async getJobFunctionDistribution(
		projectId: number,
		formData: TProjectInsightsPayload,
		config = {},
	) {
		return await this.doPost(
			`/projects/${projectId}/specialism-positions-report`,
			formData,
			config,
		);
	}

	// eslint-disable-next-line
	async getCountryReport(projectId: number, formData: TProjectInsightsPayload, config = {}) {
		return await this.doPost(
			`/projects/${projectId}/candidate-country-report`,
			formData,
			config,
		);
	}

	async getProjectFrequentlyHiredFrom(
		projectId: number,
		formData: TProjectInsightsPayload & {pagination: TPaginationParam},
		config = {},
	) {
		return await this.doPost(`/projects/${projectId}/frequently-hired-from`, formData, config);
	}

	async getIndustriesBackgroundReport(
		projectId: number,
		formData: TProjectInsightsPayload,
		config = {},
	) {
		return await this.doPost(
			`/projects/${projectId}/industries-background-report`,
			formData,
			config,
		);
	}
}

const mapxProjectInsightsApi = new MapxProjectInsightsApi();

export default mapxProjectInsightsApi;
